"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.176.2
//   protoc               v5.27.0
// source: v1/multichain-aggregator.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashType = exports.TokenType = void 0;
/* eslint-disable */
var TokenType;
(function (TokenType) {
    TokenType["TOKEN_TYPE_UNSPECIFIED"] = "TOKEN_TYPE_UNSPECIFIED";
    TokenType["TOKEN_TYPE_ERC_20"] = "TOKEN_TYPE_ERC_20";
    TokenType["TOKEN_TYPE_ERC_721"] = "TOKEN_TYPE_ERC_721";
    TokenType["TOKEN_TYPE_ERC_1155"] = "TOKEN_TYPE_ERC_1155";
    TokenType["TOKEN_TYPE_ERC_404"] = "TOKEN_TYPE_ERC_404";
    TokenType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TokenType || (exports.TokenType = TokenType = {}));
var HashType;
(function (HashType) {
    HashType["HASH_TYPE_BLOCK"] = "HASH_TYPE_BLOCK";
    HashType["HASH_TYPE_TRANSACTION"] = "HASH_TYPE_TRANSACTION";
    HashType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(HashType || (exports.HashType = HashType = {}));
